import { http } from './config'

export default {
  
  getAllFragilities: () => {
    return http.get('fragilities')
  },

  getFilteredFragility: (params) => {
    return http.get('fragilities', {params})
  },

  getFragilityById: (fragilityId) => {
    return http.get('fragilities/' + fragilityId)
  },

  createFragility: (fragilityParams) => {
    return http.post('fragilities', {
      name: fragilityParams.name,
      level: fragilityParams.level,
    }
  )},

  updateFragility: (fragilityParams) => {
    return http.put('fragilities/' + fragilityParams.id, {
      name: fragilityParams.name,
      level: fragilityParams.level,
    }
  )},

  deleteFragility: (fragilityId) => {
    return http.delete('fragilities/' + fragilityId)
  },

}
